import {
    Component,
    Input,
    OnChanges,
    Output,
    EventEmitter,
} from '@angular/core';
import { environment } from '@env/environment';
import {
    AuthenticationService,
    EspaceDocumentaireService,
} from '@kv-common-components/kx-services';
import { NGXLogger } from 'ngx-logger';
import { CommonDossierComponent } from '@kv-common-components/kv-common-components';

@Component({
    selector: 'app-espace-doc-mobile',
    templateUrl: 'espace-doc-mobile.component.html',
    styleUrls: ['espace-doc-mobile.component.scss']
})
export class EspaceDocMobileComponent
    extends CommonDossierComponent
    implements OnChanges
{
    @Input() currentContextDossier;
    @Input() allEspaceDoc;
    @Output() backToSelectionPage = new EventEmitter<boolean>();
    idPropositionPrincipale: any;
    codeProduit: any;
    filterDoc: any;
    selectedPill: any;

    constructor(
        private authenticationService: AuthenticationService,
        protected espaceDocumentaireService: EspaceDocumentaireService,
        protected logger: NGXLogger
    ) {
        super(logger, espaceDocumentaireService);
        this.currentUser = this.authenticationService.currentUserValue;
    }

    ngOnChanges(): void {
        this.idPropositionPrincipale =
            this.currentContextDossier.emprunteur.assurance.idPropositionPrincipale;
        this.codeProduit =
            this.currentContextDossier.emprunteur.assurance.offreSelectionnee.codeProduit;
    }

    backToSelection() {
        this.backToSelectionPage.emit(false);
    }

    selectPill(selectedPill: string) {
        this.selectedPill = selectedPill;
        this.filterDocByTypologie(
            selectedPill,
            this.allEspaceDoc,
            environment.contractualDocument,
            environment.infoDocument
        );
    }
}
